import apiInstance from "api";
import {
  getLocationDataFailure,
  getLocationDataStart,
  getLocationDataSuccess,

  getPermissionLocationDataFailure,
  getPermissionLocationDataStart,
  getPermissionLocationDataSuccess,

  addLocationStart,
  addLocationSuccess,
  addLocationFailure,
  deleteLocationStart,
  deleteLocationSuccess,
  deleteLocationFailure,
  editLocationStart,
  editLocationSuccess,
  editLocationFailure

} from "./reducers";

export const getLocationData = (token, organizationId) => {
  return async (dispatch) => {
    try {
      dispatch(getLocationDataStart());
      let response = null
      const params = {};
      if (token) params.token = token;
      // Platform admins can target another org by id; the backend ignores
      // this for non-admins (falls back to the caller's claim org).
      if (organizationId) params.organizationId = organizationId;
      response = await apiInstance.get("/locations", { params });

      dispatch(getLocationDataSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(getLocationDataFailure(error.response.data));
      } else {
        dispatch(getLocationDataFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const addLocationData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(addLocationStart());
      const response = await apiInstance.post("/locations", {
        ...data,
      });
      dispatch(addLocationSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(addLocationFailure(error.response.data));
      } else {
        dispatch(addLocationFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const editLocationAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(editLocationStart());
      const response = await apiInstance.put("/locations", {
        ...data,
      });
      dispatch(editLocationSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(editLocationFailure(error.response.data));
      } else {
        dispatch(editLocationFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const deleteLocationAction = (locationId) => {
  return async (dispatch) => {
    try {
      dispatch(deleteLocationStart());
      const response = await apiInstance.delete(`/locations/${locationId}`);
      dispatch(deleteLocationSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(deleteLocationFailure(error.response.data));
      } else {
        dispatch(deleteLocationFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const getPermissionLocationData = (token, permissionId) => {
  return async (dispatch) => {
    try {
      dispatch(getPermissionLocationDataStart());
      let response = null
      const params = token ? { token, permissionId } : {};
      response = await apiInstance.get("/roles-permissions/location-permissions", { params });
      dispatch(getPermissionLocationDataSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(getPermissionLocationDataFailure(error.response.data));
      } else {
        dispatch(getPermissionLocationDataFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

// ----- Site flag + platform-system overrides -------------------------
// Plain promise-returning helpers (no redux state) — the site-detail
// panel calls these directly and re-fetches the tree afterwards via
// getLocationData.

// `config` (optional) lets callers attach a per-request X-Acting-Org-Id
// header so an enterprise OWNER can manage a managed client's locations
// (bay/site flags, per-site system overrides) from the Build Hierarchy
// editor.
export const setLocationSite = async (locationId, { isSite, timezone }, config) => {
  const body = { isSite };
  if (timezone !== undefined) body.timezone = timezone;
  const response = await apiInstance.patch(`/locations/${locationId}/site`, body, config);
  return response.data?.data;
};

// Bay flag — mirrors setLocationSite but for the IsBay column. Used by
// the Manage Bay modal launched from the Build Hierarchy editor.
export const setLocationBay = async (locationId, { isBay }, config) => {
  const response = await apiInstance.patch(`/locations/${locationId}/bay`, { isBay }, config);
  return response.data?.data;
};

// Batch-create bays 2..upTo as siblings of an anchor location. Each
// new row is flagged isBay=true. Returns `{ created, skipped, locations }`.
// Backs the "Index Bays" action on the Build Hierarchy editor.
export const indexBays = async (anchorLocationId, { prefix, upTo }, config) => {
  const response = await apiInstance.post(
    `/locations/${anchorLocationId}/index-bays`,
    { prefix, upTo },
    config
  );
  return response.data?.data;
};

export const getLocationSystems = async (locationId, config) => {
  const response = await apiInstance.get(`/locations/${locationId}/systems`, config);
  return response.data?.data;
};

export const upsertLocationSystemOverride = async (locationId, systemId, { isEnabled, notes }, config) => {
  const response = await apiInstance.put(
    `/locations/${locationId}/systems/${systemId}`,
    { isEnabled, notes: notes ?? null },
    config
  );
  return response.data?.data;
};

export const clearLocationSystemOverride = async (locationId, systemId, config) => {
  const response = await apiInstance.delete(`/locations/${locationId}/systems/${systemId}`, config);
  return response.data?.data;
};